import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantProfileView } from "./TenantProfileView";
import { TenantProfileViewStore } from "../../store/TenantProfileViewStore";
import { useStore } from "../../../../hooks";

export const TenantProfileViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantProfile/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantProfileViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "business",
              label: rootStore.langStore.groupTenantProfileBusinessLabel,
            },
            {
              id: "address",
              label: rootStore.langStore.groupTenantProfileAddressLabel,
            },
            {
              id: "billing",
              label: rootStore.langStore.groupTenantProfileBillingLabel,
            },
            {
              id: "printer",
              label: rootStore.langStore.groupTenantProfilePrinterLabel,
            },
            {
              id: "integrationsSadaic",
              label:
                rootStore.langStore.groupTenantProfileIntegrationsSadaicLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantProfileView tenantProfileViewStore={store} />
      </PageLayout>
    </div>
  );
});
